import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  return <section className="py-20 bg-white" data-id="element-350">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-351">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-352">
          Is This Right For You?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-353">
          {/* Perfect For */}
          <div className="bg-green-50 rounded-2xl p-8 border border-green-200" data-id="element-354">
            <h3 className="text-xl font-bold text-green-800 mb-6 font-serif" data-id="element-355">
              This is PERFECT for you if:
            </h3>
            <ul className="space-y-5" data-id="element-356">
              <li className="flex items-start" data-id="element-357">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center mt-0.5" data-id="element-358">
                  <Check className="w-4 h-4 text-white" data-id="element-359" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-360">
                  You're 45+ and tired of looking "6 months pregnant" by dinner
                  time
                </span>
              </li>
              <li className="flex items-start" data-id="element-361">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center mt-0.5" data-id="element-362">
                  <Check className="w-4 h-4 text-white" data-id="element-363" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-364">
                  You want natural solutions (no drugs, no surgery)
                </span>
              </li>
              <li className="flex items-start" data-id="element-365">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center mt-0.5" data-id="element-366">
                  <Check className="w-4 h-4 text-white" data-id="element-367" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-368">
                  You're willing to dedicate 5 minutes each morning
                </span>
              </li>
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-red-50 rounded-2xl p-8 border border-red-200" data-id="element-369">
            <h3 className="text-xl font-bold text-red-800 mb-6 font-serif" data-id="element-370">
              This is NOT for you if:
            </h3>
            <ul className="space-y-5" data-id="element-371">
              <li className="flex items-start" data-id="element-372">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-500 flex items-center justify-center mt-0.5" data-id="element-373">
                  <X className="w-4 h-4 text-white" data-id="element-374" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-375">
                  You're looking for a "magic pill" that requires zero effort
                </span>
              </li>
              <li className="flex items-start" data-id="element-376">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-500 flex items-center justify-center mt-0.5" data-id="element-377">
                  <X className="w-4 h-4 text-white" data-id="element-378" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-379">
                  You want extreme weight loss in 48 hours
                </span>
              </li>
              <li className="flex items-start" data-id="element-380">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-500 flex items-center justify-center mt-0.5" data-id="element-381">
                  <X className="w-4 h-4 text-white" data-id="element-382" />
                </div>
                <span className="ml-4 text-stone-700" data-id="element-383">
                  You refuse to change anything about your routine
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}